/**
 * R15.1-06 — nome de tela do link de uso unico com Pix + cartoes (o produto `sales_link`).
 * Rotas, slugs e nomes internos seguem `links-de-venda`/`sales_links` de proposito: links
 * ja enviados e perfis de acesso nao mudam. O rotulo do menu de perfis vem da API
 * (`AdminAccess::SectionCatalog`) e os e-mails, do mailer: mudar o nome e mudar la tambem.
 */
export const SALES_LINK_COPY = {
  name: 'Link de condições',
  plural: 'Links de condições',
  newTitle: 'Novo link de condições',
  detailTitle: (id?: number) => (id === undefined ? 'Link de condições' : `Link de condições #${id}`),
  cancelTitle: 'Cancelar link de condições?',
  empty: 'Nenhum link de condições encontrado',
  loading: 'Carregando links de condições...',
  loadError: 'Não foi possível carregar os links de condições.',
  notFound: 'Link de condições não encontrado.',
  publicLoadError: 'Não foi possível carregar o link de condições.',
  publicInvalidTitle: 'Link de condições inválido',
  publicExpired: 'Este link de condições não está mais válido. Fale com quem enviou o link para receber um novo.',
  publicCancelled: 'Este link de condições foi cancelado. Fale com quem enviou o link.',
  whatsappIntro: (planName: string, total: string) =>
    `Olá! Segue o link de condições para concluir a sua inscrição no plano ${planName} da MedHunter.${total}`,
  whatsappHowTo: 'Nele você vê a divisão do pagamento e paga cada parte (Pix e cartão).',
  whatsappValidity: (date: string) => `O link vale até ${date} e só pode ser usado uma vez.`,
} as const
